module.exports = __webpack_public_path__ + "img/ok.06980212.svg";